const Decimal = require("decimal.js");

function operation(a, operation, b) {
  const x = new Decimal(a);
  const y = new Decimal(b);
  let result;

  switch (operation) {
    case "add":
      result = x.plus(y);
      break;
    case "sub":
      result = x.minus(y);
      break;
    case "mul":
      result = x.times(y);
      break;
    case "div":
      if (y.isZero()) throw new Error("Division by zero");
      result = x.dividedBy(y);
      break;
    default:
      throw new Error(`Unsupported operation: ${operation}`);
  }

  // Truncate (not round) to 8 decimal places and return as number
  return result.toDecimalPlaces(8, Decimal.ROUND_DOWN).toNumber();
}

function fixedtillNumber(input, till) {
  return new Decimal(input)
    .toDecimalPlaces(till, Decimal.ROUND_DOWN) // Truncate instead of rounding
    .toNumber();
}

function fixedtillString(input, till) {
  const fixed = new Decimal(input)
    .toDecimalPlaces(till, Decimal.ROUND_DOWN)
    .toFixed(till); // ensures trailing zeros

  // Remove trailing zeros after decimal, and remove decimal if not needed
  return fixed.replace(/\.?0+$/, "");
}

const Decimal_util = {
  operation,
  fixedtillNumber,
  fixedtillString,
};

export { Decimal_util };
